export const assessmentTemplate = [
  {
    _id: "omniLeaderOnboard",
    omniAudit: {
      auditVersion: "1",
      omniRevision: "1",
      omniSchema: "assessmentTemplate",
      omniSchemaVersion: "1",
      writtenBy: null,
      createdBy: "melissaadmin9999",
      createdDate: "2024-20-21T00:00:00Z",
      modifiedBy: "melissaadmin9999",
      modifiedDate: "2024-24-21T00:00:00Z",
      isActive: true,
    },
    omniData: {
      omniType: "omniLeadereOnboard",
      omniTypeVersion: 1,
      title: "Introductions",
      purpose: "Introduce leaders to the Empire team",
      description:
        "The information you provide will help us understand your goals. The journey to building an EMPIRE starts here.",
      duration: "Around 5 minutes",
      directions: "Follow the onscreen instructions after you begin.",
      attribution: "",
      validated: "true",
      startDate: null,
      completeDate: null,
      selfAssessment: true,
      questions: [
        {
          omniID: "ol0",
          shortTitle: "subjectBusinessPillar",
          numberText: "0",
          text: "Which Business Pillar best represents your role within your organization?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "button",
          multiSelectText: "false",
          answerOptions: [
            {
              value: "leadership",
              text: "Leadership",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "operations",
              text: "Operations",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "marketing",
              text: "Marketing",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "finance",
              text: "Finance",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "personnel",
              text: "Personnel",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "ol1",
          shortTitle: "subjectExperience",
          numberText: "1",
          text: "How long have you been on this team?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "button",
          multiSelectText: "false",
          answerOptions: [
            {
              value: "lessThanOneYear",
              text: "Less than one year",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "oneToThreeYears",
              text: "One to three years",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "threeToFiveYears",
              text: "Three to five years",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "fiveToTenYears",
              text: "Five to ten years",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "moreThanTenYears",
              text: "More than ten years",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "ol2",
          shortTitle: "subjectPersonalWins",
          numberText: "2",
          text: "How many personal wins do you have over the last 14 days?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "button",
          multiSelectText: "false",
          answerOptions: [
            {
              value: "none",
              text: "None",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "oneToThree",
              text: "1 to 3",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "fourToSix",
              text: "4 to 6",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "seventToNine",
              text: "7 to 9",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "tenOrMore",
              text: "10+",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "ol3",
          shortTitle: "subjectProfessionalWins",
          numberText: "3",
          text: "How many professional wins have you had over the last 14 days?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "button",
          multiSelectText: "false",
          answerOptions: [
            {
              value: "none",
              text: "None",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "oneToThree",
              text: "1 to 3",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "fourToSix",
              text: "4 to 6",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "seventToNine",
              text: "7 to 9",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "tenOrMore",
              text: "10+",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "ol4",
          shortTitle: "subjectResponsibilities",
          numberText: "4",
          text: "What are your responsibilities in your current role?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "freeText",
          multiSelectText: "false",
          answerOptions: [
            {
              value: "",
              text: "",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "ol5",
          shortTitle: "subjectChallenges",
          numberText: "4",
          text: "What are the challenges facing your business?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "freeText",
          multiSelectText: "false",
          answerOptions: [
            {
              value: "",
              text: "",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: true,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
      ],
      assessmentResults: { finalResult: null },
    },
  },
];
export const assessmentScoring = [
  {
    typeID: "eosOnboarding",
    algorithms: [
      {
        name: "sum",
        minScore: 0,
        maxScore: 0,
        formula: null,
        questions: [],
      },
    ],
  },
];
